const findUpTagByClass = (el, tag) => {
    do {
        // console.log(el.classList)
        if (el && el.classList && el.classList.contains(tag)) {
            return el;
        }

        if (el && el.parentNode) {
            el = el.parentNode;
        } else {
            return null
        }
        // console.log(el.className, el.id, el)
    } while (el)
}

const findUpTagByType = (el, type) => {

    // console.log('searching', window.parent, window.parent.nodeName, el.getBoundingClientRect());
    // return window.document;

    // window.parent.document.getElementsByTagName('iframe')[0].getBoundingClientRect()

    do {
        // console.log(el.classList)
        if (el && el.nodeName == type) {
            return el;
        }

        if (el && el.parentNode) {
            el = el.parentNode;
        } else {
            return null
        }
        // console.log(el.className, el.id, el)
    } while (el)
}


function findElement(win, id)
{
    var el = win.document.getElementById(id);
    if(el) return el;
    for(var i=0; i<win.frames.length; i++)
    {
        var el = findElement(win.frames[i].window, id);
        if(el) return el;
    }

    return null;
}


// const getAggregatedFrameOffset = (el) => {
//     window.document.getElementsByTagName('iframe')
//     .filter((w) => )
// }


export {
    findUpTagByClass,
    findUpTagByType
    // findUpTagById
};